import styled from 'styled-components';

export const Iframe = styled.iframe`
  position: fixed;
  width: 100%;
  height: 100%;
`;
